
const newLinks = document.querySelectorAll('.scroll-link');

(function () {

  if (newLinks) {
    const changeNav = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio >= 1) {
          const id = entry.target.getAttribute('id');


          newLinks.forEach((link) => {
            link.style.color = '';
          });

          const activeLinks = document.querySelectorAll(`.scroll-link[href="#${id}"]`);
          activeLinks.forEach((link) => {
            link.style.color = '#18F5C9';
          });
        }
      });
    }

    const options = {
      threshold: 1
    }

    const observer = new IntersectionObserver(changeNav, options);


    const sections = document.querySelectorAll('.scroll-section');
    sections.forEach((section) => {
      observer.observe(section);
    });
  } else {
    return;
  }
})();

